@if (ownedStrategies && ownedStrategies.length) {
  <div>
    <div class="mobile-swiper">
      @for (ownedStrategy of ownedStrategies; track $index) {
        <div class="mt-4">
          <libero-owned-strategy-card [strategy]="ownedStrategy" [isDraft]="ownedStrategy.isDraft" [isMobile]="true"></libero-owned-strategy-card>
        </div>
      }
    </div>
    <div class="desktop-swiper">
      @if (showSimpleSwiper()) {
        <div
          class="swiperless-container"
        [ngClass]="{
          'swiperless-container--single': ownedStrategies.length === 1,
          'swiperless-container--two': ownedStrategies.length  === 2
        }"
          >
          @for (ownedStrategy of ownedStrategies; track $index) {
            <div class="relative-card-container">
              <libero-owned-strategy-card [strategy]="ownedStrategy" [isDraft]="ownedStrategy.isDraft" [isMobile]="false"></libero-owned-strategy-card>
            </div>
          }
        </div>
      } @else {
        <div class="desktop-owned-swiper-prev swiper-arrow swiper-arrow--left">
          <svg-icon src="assets/icons/arrow.svg" [svgStyle]="{ 'width.px':18 }"></svg-icon>
        </div>
        <swiper
          [slidesPerView]="slidesPerView"
        [pagination]="{
          clickable: true
        }"
        [navigation]="{
          enabled: true,
          nextEl:'.desktop-owned-swiper-next',
          prevEl:'.desktop-owned-swiper-prev',
          disabledClass: 'swiper-arrow--disabled'
        }"
          [slidesOffsetBefore]="28"
          [slidesOffsetAfter]="28"
          [freeMode]="true"
          >
          @for (ownedStrategy of ownedStrategies; track $index) {
            <ng-template swiperSlide>
              <libero-owned-strategy-card [strategy]="ownedStrategy" [inCarousel]="true" [isDraft]="ownedStrategy.isDraft"></libero-owned-strategy-card>
            </ng-template>
          }
        </swiper>
        <div class="desktop-owned-swiper-next swiper-arrow swiper-arrow--right">
          <svg-icon src="assets/icons/arrow.svg" [svgStyle]="{ 'width.px':18, 'transform': 'rotate(180deg)' }"></svg-icon>
        </div>
      }
    </div>
  </div>
} @else {
  <div class="no-data-container">
    {{ 'global.error.noData' | translate }}
  </div>
}
